const agentBaseUrl = '/Agent';

export default {
    getAgentByIdUrl: (id) => `${agentBaseUrl}?AgentId=${id}`,
    getAgentByPortfolioIdUrl: (portfolioId) =>
        `${agentBaseUrl}/byPortfolioId?PortfolioId=${portfolioId}`,
    inquiry: () => `${agentBaseUrl}/inquiry`,
};
